module.exports = __webpack_public_path__ + "media/images/samples/1280x768/8-054460ac3431471d78c0e1939ddaccd4.jpg";